import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectAllBrandsModels } from 'store/selectors';
import * as S from './SelectContent.styled';
import { TypeOfItem } from 'components';

const SelectContent = ({ excludeSet, includeSet, deleteIncAction, deleteExcAction }) => {
  const allBrandsModels = useSelector(selectAllBrandsModels);
  const counterOrBrandToData = useMemo(
    () =>
      Object.fromEntries(
        allBrandsModels.flatMap((brandData) => [
          [brandData.brand, brandData],
          ...brandData.models.map((model) => [model.counter, model]),
        ]),
      ),
    [allBrandsModels],
  );
  const sortAsc = (list) => {
    const sortList = [...list];
    const newList = [];
    const newFlatList = [];
    sortList.forEach((inc) => {
      newList.push(counterOrBrandToData[inc]);
    });
    newList.sort((a, b) => {
      if (a.counter && b.counter) {
        return a.model.localeCompare(b.model);
      } else if (!a.counter && b.counter) {
        return a.brand.localeCompare(b.model);
      } else if (a.counter && !b.counter) {
        return a.model.localeCompare(b.brand);
      } else {
        return a.brand.localeCompare(b.brand);
      }
    });
    newList.forEach((inc) => {
      newFlatList.push(inc.counter ? inc.counter : inc.brand);
    });
    return newFlatList;
  };

  return (
    <S.Container>
      <S.IncludeSection isExclude={!!excludeSet.length}>
        {sortAsc(includeSet).map((inc) => (
          <TypeOfItem
            key={inc}
            item={counterOrBrandToData[inc]}
            deleteIncAction={deleteIncAction}
          />
        ))}
      </S.IncludeSection>
      {excludeSet.length ? (
        <S.ExcludeSection>
          {sortAsc(excludeSet).map((exc) => (
            <TypeOfItem
              key={exc}
              item={counterOrBrandToData[exc]}
              deleteIncAction={deleteIncAction}
              deleteExcAction={deleteExcAction}
              exclude
            />
          ))}
        </S.ExcludeSection>
      ) : null}
    </S.Container>
  );
};

export default SelectContent;
